<mat-card matRipple
          (click)="onClicked()">
    <img *ngIf="user.avatar"
         [src]="conf.storageRootUrl + user.avatar"
         class="avatar"  alt="avatar"/>
    <mat-icon *ngIf="!user.avatar"
              class="avatar">
        account_circle
    </mat-icon>
    <div>
        <div class="title">{{ user.firstName + ' ' +user.lastName }}</div>
        <div class="sub-title">
            <span *ngFor="let role of roles; let i = index">{{ role.name }}<span *ngIf="i < roles.length - 1">, </span></span>
        </div>
    </div>
</mat-card>
